"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileDrop = void 0;
const react_1 = __importDefault(require("react"));
const UiKitLite_1 = require("../UiKitLite");
const FileDrop = () => {
    const onFiles = (files) => {
        alert('Number of files selected: ' + files.length);
    };
    return react_1.default.createElement(UiKitLite_1.UiKitLite.Form.FileDrop, { onFiles: onFiles, accept: ['.pdf'], maxFileSizeBytes: 1024 * 1024 * 50 });
};
exports.FileDrop = FileDrop;
